import React from 'react'
import HeadingText from '../ActionCommonComponent/HeadingText';
import InfoBox from '../../components/InfoBox';
import { formtDt } from '../../../../util/AppUtils';


const CreatedMosRevision = ({ data={} }) => {

    const { version_id, comment, user_id, new_content_snapshot, version_content } = data;

  return <>
    <HeadingText heading="Associated Version" text={version_id} />
    <HeadingText heading="Activity" text={data.action} />
    <HeadingText heading="Details (Read Only)">
        <InfoBox heading={"Draft New Revision"}>

            <div style={{ marginBottom: "17px" }}>
                <HeadingText
                heading="Revision:"
                text={version_content?.rev}
                normal={true}
                />
            </div>

             <div style={{ marginBottom: "17px" }}>
                <HeadingText
                heading="Date Released:"
                text={formtDt(version_content?.date_released)}
                normal={true}
                />
            </div>

            <div style={{ marginBottom: "17px" }}>
                <HeadingText
                heading="Revision Details:"
                text={version_content?.revision_details}
                normal={true}
                />
            </div>

            <div style={{ marginBottom: "17px" }}>
                <HeadingText
                heading="Submitter:"
                text={"MAINTAINED OUTSIDE OF SYSTEM"}
                normal={true}
                />
            </div>

            <div style={{ marginBottom: "17px" }}>
                <HeadingText
                heading="Approvers:"
                text={"MAINTAINED OUTSIDE OF SYSTEM"}
                normal={true}
                />
            </div>

            <div style={{ marginBottom: "17px" }}>
                <HeadingText
                heading="Released By:"
                text={"MAINTAINED OUTSIDE OF SYSTEM"}
                normal={true}
                />
            </div>

            <div style={{ marginBottom: "17px" }}>
                <HeadingText
                heading="References:"
                text={version_content?.reference}
                normal={true}
                />
            </div>

            <div style={{ marginBottom: "17px" }}>
                <HeadingText
                heading="Status:"
                text={"MAINTAINED OUTSIDE OF SYSTEM"}
                normal={true}
                />
            </div>
        </InfoBox>
    </HeadingText>
  </>
}

export default CreatedMosRevision